/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Price_Period_MonthlyInputs */



/**
* | output |
* | --- |
* | "USD / month · billed monthly" |
*
* @param {Signup_Price_Period_MonthlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_price_period_monthly = /** @type {((inputs?: Signup_Price_Period_MonthlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Price_Period_MonthlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("USD / mois · facturation mensuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("USD / Monat · monatliche Abrechnung")
	if (locale === "it") return /** @type {LocalizedString} */ ("USD / mese · fatturazione mensile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("USD / месяц · ежемесячная оплата")
	if (locale === "es") return /** @type {LocalizedString} */ ("USD / mes · facturación mensual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("USD / 月 · 按月计费")
	if (locale === "ja") return /** @type {LocalizedString} */ ("USD / 月・月払い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("USD / माह · मासिक बिलिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("USD / mês · faturação mensal")
	return /** @type {LocalizedString} */ ("USD / month · billed monthly")
});